import React, { useState } from "react";

import { Button, TextField } from "@mui/material";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { useActionHook, useDidUpdate } from "hooks";
import { IApiServiceError, useDealIdSelector, useDealTitleSelector } from "store";
import { useDealActions } from "store";

import "./RenameModal.styles.scss";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  borderRadius: "10px"
};
interface IRenameProps {
  isOpen: boolean;
  close: () => void;
}

export const RenameModal: React.FC<IRenameProps> = ({ isOpen, close }) => {
  const { updateDealAction } = useDealActions();
  const id = useDealIdSelector();
  const title = useDealTitleSelector();
  const [value, setValue] = useState<string>(title || "");
  const [error, setError] = useState<string>("");

  const resetError = () => {
    setError("");
  };

  const resetAndClose = () => {
    resetError();
    close();
  };

  const { action: updateDealName } = useActionHook(updateDealAction, {
    onSuccess: () => {
      resetAndClose();
    },
    onReject: (e: IApiServiceError) => setError(e.errors.title[0])
  });

  useDidUpdate(() => {
    if (title) {
      setValue(title);
    }
  }, [isOpen]);

  const handleSubmit = () => {
    if (id) {
      updateDealName({ dealId: id, title: value });
    }
  };

  return (
    <Modal open={isOpen}>
      <Box sx={style}>
        <div className="rename-deal-modal">
          <div className="head">
            <span>Edit Deal Name</span>
          </div>
          <div className="body">
            <TextField
              fullWidth
              label="Rename"
              value={value}
              onChange={(e) => {
                setValue(e.target.value);
                resetError();
              }}
              error={!!error}
              helperText={error}
            />
          </div>
          <div className="footer">
            <Button variant="outlined" onClick={resetAndClose}>
              Cancel
            </Button>
            <Button disabled={value === title || !value || !!error.length} variant="contained" onClick={handleSubmit}>
              Save
            </Button>
          </div>
        </div>
      </Box>
    </Modal>
  );
};
